var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { id: "dashboard-main" } }, [
    _c("div", { staticClass: "row m-0" }, [
      _c(
        "div",
        { staticClass: "col-sm-12", attrs: { "min-height": "100px" } },
        [_c("header-component", { attrs: { selection: _vm.selection } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row m-0 dashboard-content" }, [
      _c(
        "div",
        { staticClass: "col-1" },
        [_c("menu-component", { attrs: { selection: _vm.selection } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [_c("content-component", { attrs: { selection: _vm.selection } })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }